// simpleWebSocketClient.ts
import WebSocket from 'isomorphic-ws';
import Long from 'long';
import { tdx_request, tdx_response } from '../tdx_proto/bundle';

export class AlertsWebSocketClient {
    private ws: WebSocket;
    private isOpen: boolean = false;
    private pending: Map<string, (res: Uint8Array) => void> = new Map();

    constructor(private url: string) {
        this.ws = new WebSocket(url);
        this.ws.binaryType = "arraybuffer";

        this.ws.onopen = () => {
            this.isOpen = true;
            console.log('✅ WebSocket connected');
        };

        this.ws.onmessage = (event: MessageEvent | { data: ArrayBuffer }) => {
            try {
                const raw = new Uint8Array(event.data);
                const decoded = tdx_response.Response.decode(raw);
                const key = Long.fromValue(decoded.id ?? 0).toString();
                const resolver = this.pending.get(key);
                if (resolver) {
                    this.pending.delete(key);
                    resolver(raw);
                } else {
                    console.warn(`No handler for response id: ${key}`);
                }
            } catch (err) {
                console.error('Failed to decode message', err);
            }
        };

        this.ws.onerror = (err) => {
            console.error('WebSocket error:', err);
        };

        this.ws.onclose = () => {
            this.isOpen = false;
            console.log('WebSocket closed');
        };
    }
    public is_open():Boolean {
        return this.isOpen;
    }

    private generateRequestId(): Long {
        return Long.fromNumber(Date.now() + Math.floor(Math.random() * 1000));
    }

    async sendAndWaitForAlerts(req: tdx_request.Request): Promise<tdx_response.Response> {
        if (!this.isOpen) {
            throw new Error('WebSocket not open');
        }

        const id = this.generateRequestId();
        req.id = id;

        const key = id.toString();
        const data = tdx_request.Request.encode(req).finish();

        return new Promise<tdx_response.Response>((resolve, reject) => {
            this.pending.set(key, (res: Uint8Array) => {
                try {
                    resolve(tdx_response.Response.decode(res));
                } catch (e) {
                    reject(e);
                }
            });
            // console.log('Sending request with id:', key);
            this.ws.send(data);
            // console.log('Request sent:', req);

            setTimeout(() => {
                if (this.pending.has(key)) {
                    this.pending.delete(key);
                    reject(new Error(`Timeout waiting for response id: ${key}`));
                }
            }, 1e5);
        });
    }

    close() {
        this.ws.close();
    }
}
